const PageWrapper = ({ children }) => {
	const wrapperStyle = {
		padding: "0px 0px",
	};

	return <div style={wrapperStyle}>{children}</div>;
};

export default PageWrapper;
